<template>
  <v-app class="app dashboard" id="inspire">
    <app-drawer :show-drawer="showDrawer" class="app--drawer"></app-drawer>
    <app-toolbar
      :notificationsTotal="notificationsTotal"
      @side-icon-click="handleDrawerVisiable"
      class="app--toolbar"
    ></app-toolbar>

    <v-content>
      <page-header></page-header>
      <div class="page-wrapper">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <v-footer class="white--text" color="primary">
        <v-layout row wrap>
          <v-flex md6 pl-3 pr-3 text-sm-left xs12>
            <div class="caption">
              Transit &copy; {{ new Date().getFullYear() }}
              <a
                class="white--text"
                href="http://www.pharma-customssolutions.com/"
                target="_blank"
                >Pharma Customs Solutions</a
              >
            </div>
          </v-flex>
          <v-flex md6 pl-3 pr-3 text-md-right text-sm-left xs12>
            <div class="caption">
              Desarrollado por
              <a
                class="white--text"
                href="http://www.inventacosas.com/"
                target="_blank"
                >Inventario</a
              >
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>

    <app-fab></app-fab>
    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
    <v-snackbar
      :color="snack.color"
      :timeout="3000"
      right
      top
      v-model="snack.show"
    >
      {{ snack.message }}
      <v-btn @click="snack.show = false" flat>Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import AppFab from '@/components/AppFab'
import PageHeader from '@/components/PageHeader'
import loading from './../../views/dialog/DialogLoading'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    loading,
  },

  data() {
    return {
      showDrawer: Boolean,
      notificationsTotal: 0,
      showDrawerRight: false,
      loading: false,
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
    }
  },
  methods: {
    handleDrawerVisiable() {
      this.showDrawer = !this.showDrawer
    },
    openFile(file) {
      this.loading = true
      // This time is only to show the animation.
      setTimeout(() => {
        this.loading = false
        window.location.href = this.$config.API_URL + file
      }, 3000)
    },
  },
  sockets: {
    invoicesTransitFile(response) {
      this.openFile(response.file)
    },

    labsFile(response) {
      this.openFile(response.file)
    },
    distFile(response) {
      this.openFile(response.file)
    },
    productBatchesFile(response) {
      this.openFile(response.file)
    },
    downloadInvoiceAttachments(response) {
      this.openFile(response.file)
    },
    usersFile(response) {
      this.openFile(response.file)
    },
    realtimeFeed(data) {
      this.snack = {
        show: true,
        color: 'black',
        message: data.action,
      }
      this.$store.dispatch('feeds/save', data).then(total => {
        this.notificationsTotal = total
      })
    },
  },
}
</script>

<style scoped lang="stylus">
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
